/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {

    Select2Default();
    Select2RemoteAjax();

    /**
     * Add the data-method="delete" forms to all delete links
     */
    addDeleteForms();

    /**
     * Tooltip setup
     * */
    $('[data-toggle="tooltip"]').tooltip();

    /**
     * Ajax setup
     * */
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function (){
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    window.FormSubmitDisable = function (){
        $('form').submit(function () {
            disableSubmitButtons($(this));
            return true;
        });
    }

    /**
     * Loading Button
     */
    $(".btn-loading").click(function() {
        // disable button
        $(this).prop("disabled", true);
        // add spinner to button
        $(this).html(
            '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Đang xử lý...'
        );
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function(e) {
        e.preventDefault();

        Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger mr-2'
            },
            buttonsStyling: false
        }).fire({
            title: 'Bạn có chắc bạn muốn xóa mục này?',
            showCancelButton: true,
            confirmButtonText: 'Xác nhận xóa',
            cancelButtonText: 'Để sau',
            icon: 'warning',
            reverseButtons: true
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });

    })
        .on('submit', 'form[name=confirm-item]', function (e) {
            e.preventDefault();

            Swal.mixin({
                customClass: {
                    confirmButton: 'btn btn-success',
                    cancelButton: 'btn btn-danger mr-2'
                },
                buttonsStyling: false
            }).fire({
                title: 'Bạn có chắc chắn muốn làm điều này?',
                showCancelButton: true,
                confirmButtonText: 'Tiếp tục',
                cancelButtonText: 'Hủy',
                icon: 'warning',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.submit()
                } else {
                    enableSubmitButtons($(this));
                }
            });
        })
        .on('click', 'a[name=confirm-item]', function (e) {
        /**
         * Add an 'are you sure' pop-up to any button/link
         */
        e.preventDefault();

        Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger mr-2'
            },
            buttonsStyling: false
        }).fire({
            title: 'Bạn có chắc chắn muốn làm điều này?',
            showCancelButton: true,
            confirmButtonText: 'Tiếp tục',
            cancelButtonText: 'Hủy',
            icon: 'info',
            reverseButtons: true
        }).then((result) => {
            result.value && window.location.assign($(this).attr('href'));
        });
    });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="'+hash+'"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();
});

/**
 * Select 2
 * @type {*|jQuery|HTMLElement}
 * **/
window.Select2Default = function (){
    $(".select2_default").select2({
        language: "vi",
        allowClear: true,
        selectionCssClass: 'select2_default',
        searchInputPlaceholder:'Nhập từ khóa tìm kiếm...',
        theme: 'bootstrap4',
        width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
        placeholder: $(this).data('placeholder'),
    });
}

window.Select2RemoteAjax = function (){
    var select2_suggest_category = $('.js_select2_ajax');
    select2_suggest_category.select2({
        language: "vi",
        searchInputPlaceholder:'Nhập từ khóa tìm kiếm...',
        selectionCssClass: 'js_select2_ajax',
        theme: 'bootstrap4',
        width: $(this).data('width') ? $(this).data('width') : $(this).hasClass('w-100') ? '100%' : 'style',
        allowClear: true,
        ajax: {
            url: function () {
                return $(this).attr('data-search')
            },
            dataType: 'json',
            type: "GET",
            quietMillis: 50,
            data: function (params) {
                return {q: params.term}
            },
            processResults: function (data) {
                return {
                    results: $.map(data, function (item) {
                        return {
                            id: item.id,
                            text: item.name,
                            description: item.description,
                            icon: item.icon
                        }
                    })
                };
            }
        },
        templateResult: function (data) {
            var $icon;
            if (data.icon !== '' && typeof data.icon !== "undefined"){
                $icon  =  "<div class='select2-result-repository__avatar'><i class='"+data.icon+"'></i></div>";
            } else {
                $icon  =  '';
            }

            var $container = $(
                "<div class='select2-result-repository select2-result select2-result-location clearfix'>"
                + $icon +
                "<div class='select2-result-repository__meta'>" +
                "<div class='select2-result-repository__title'></div>" +
                "<div class='select2-result-repository__description'></div>" +
                "</div>" +
                "</div>"
            );

            $container.find(".select2-result-repository__title").text(data.text);
            $container.find(".select2-result-repository__description").text(data.description);

            return $container;
        }
    }).on('select2:select', function (e) {
        var data = e.params.data;
        if (data.id == 'add'){
            $(this).empty().trigger('change');
            $($(this).attr('data-trigger')).trigger('click');
        }
    });
};


//Select 2 update
(function($) {

    var Defaults = $.fn.select2.amd.require('select2/defaults');

    $.extend(Defaults.defaults, {
        searchInputPlaceholder: ''
    });

    var SearchDropdown = $.fn.select2.amd.require('select2/dropdown/search');

    var _renderSearchDropdown = SearchDropdown.prototype.render;

    SearchDropdown.prototype.render = function(decorated) {

        // invoke parent method
        var $rendered = _renderSearchDropdown.apply(this, Array.prototype.slice.apply(arguments));

        this.$search.attr('placeholder', this.options.get('searchInputPlaceholder'));

        return $rendered;
    };

})(window.jQuery);

/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete-item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */
window.addDeleteForms = function (){
    $('[data-method]').append(function () {
        if (!$(this).find('form').length > 0) {

            var data_name = 'delete-item';
            if ($(this).attr('data-name')){
                data_name = $(this).attr('data-name');
            }

            return "\n<form action='" + $(this).attr('href') + "' method='POST' name='" + data_name + "' style='display:none'>\n" +
                "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                '</form>\n';
        } else { return '' }
    })
        .attr('href', '#')
        .attr('style', 'cursor:pointer;')
        .attr('onclick', '$(this).find("form").submit();');
}
